import api from "./api";
import API_URLS from "../../constants/api-urls";

export default class SpiritApi {
  createSpirit() {
    return api.post(API_URLS.URL.spirit.createSpirit);
  }

  getSpiritList(payload) {
    return api.post(API_URLS.URL.spirit.getSpiritList, payload);
  }

  getSpiritById(spiritId) {
    return api.get(API_URLS.URL.spirit.getSpiritById?.replace(":id", spiritId));
  }

  updateSpiritById(spiritId, payload) {
    return api.put(
      API_URLS.URL.spirit.updateSpiritById?.replace(":id", spiritId),
      payload,
    );
  }

  createSpiritLogs(payload) {
    return api.post(API_URLS.URL.spirit.createSpiritLogs, payload);
  }

  updateSpiritLogs(spiritLogId, payload) {
    return api.put(
      API_URLS.URL.spirit.updateSpiritLogs?.replace(":id", spiritLogId),
      payload,
    );
  }

  deleteSpiritLog(subLogId) {
    return api.delete(
      API_URLS.URL.spirit.deleteSpiritLogs?.replace(":id", subLogId),
    );
  }

  getSpiritLogsList(payload) {
    return api.post(API_URLS.URL.spirit.getSpiritLogsList, payload);
  }

  addWasteWaterData(payload) {
    return api.post(API_URLS.URL.spirit.addWasteWaterData, payload);
  }

  updateWasteWater(wasteWaterId, payload) {
    return api.put(
      API_URLS.URL.spirit.updateWasteWater?.replace(":id", wasteWaterId),
      payload,
    );
  }

  getWasteWaterList(payload) {
    return api.post(API_URLS.URL.spirit.getWasteWaterList, payload);
  }

  deleteWasteWater(wasteWaterId) {
    return api.delete(
      API_URLS.URL.spirit.updateWasteWater?.replace(":id", wasteWaterId),
    );
  }

  sendToSpiritProcessApi(payload) {
    return api.post(API_URLS.URL.spirit.sendToSpiritProcess, payload);
  }

  getEndOfRunCut(spiritProcessId) {
    return api.get(API_URLS.URL.spirit.getEndOfRunCut?.replace(":spiritProcessId", spiritProcessId));
  }

  saveEndOfRunCut(payload) {
    return api.post(API_URLS.URL.spirit.saveEndOfRunCut, payload);
  }

  getEndOfRunCutById(id) {
    return api.get(API_URLS.URL.spirit.getEndOfRunCutById?.replace(":id", id));
  }

  updateEndOfRunCut(id, payload) {
    return api.put(
      API_URLS.URL.spirit.updateEndOfRunCut?.replace(":id", id),
      payload
    );
  }

  deleteEndOfRunCut(id) {
    return api.delete(
      API_URLS.URL.spirit.updateEndOfRunCut?.replace(":id", id)
    );
  }
}

